import { ColumnGroupingModelResults } from '@/fragments/PlanningInboxTable/libs/useInboxColumnGroupingModel'
import { CollapsibleHeader } from '@/shared/components/GridTable/CollapsibleHeader/CollapsibleHeader'
import { GridColumnGroupingModel, GridColumnVisibilityModel } from '@mui/x-data-grid-premium'

export const columnGroupingModel: GridColumnGroupingModel = [
  {
    groupId: 'depots',
    headerName: 'Depots',
    renderHeaderGroup: (params) => {
      return <CollapsibleHeader
        groupFields={['startDepot', 'finishDepot']}
        numColumnsWhenCollapsed={1}
        {...params}
      />
    },
    children: [
      { field: 'startDepot' },
      { field: 'finishDepot' },
    ],
  },
  {
    groupId: 'startTime',
    headerName: 'Start Time',
    renderHeaderGroup: (params) => {
      return <CollapsibleHeader
        groupFields={['startTimeEarliest', 'startTimeLatest']}
        numColumnsWhenCollapsed={1}
        {...params}
      />
    },
    children: [
      { field: 'startTimeEarliest' },
      { field: 'startTimeLatest' },
    ],
  },
  {
    groupId: 'capacity',
    headerName: 'Capacity',
    renderHeaderGroup: (params) => {
      return <CollapsibleHeader
        numColumnsWhenCollapsed={1}
        groupFields={['weightCapacity', 'volumeCapacity']}
        {...params}
      />
    },
    children: [
      { field: 'weightCapacity' },
      { field: 'volumeCapacity' },
    ],
  },
  {
    groupId: 'cost',
    headerName: 'Cost',
    renderHeaderGroup: (params) => {
      return <CollapsibleHeader
        numColumnsWhenCollapsed={1}
        groupFields={['costFixed', 'costPerHour', 'costPerKm']}
        {...params}
      />
    },
    children: [
      { field: 'costFixed' },
      { field: 'costPerHour' },
      { field: 'costPerKm' },
    ],
  },
  {
    groupId: 'time',
    headerName: 'Time',
    renderHeaderGroup: (params) => {
      return <CollapsibleHeader
        numColumnsWhenCollapsed={1}
        groupFields={['maxWorkingTime', 'maxDrivingTime']}
        {...params}
      />
    },
    children: [
      { field: 'maxWorkingTime' },
      { field: 'maxDrivingTime' },
    ],
  },
]

export const useColumnGroupingModel = (): ColumnGroupingModelResults => {
  const initialColumnGroupVisibility: GridColumnVisibilityModel = {
    depots: true,
    startTime: true,
    capacity: true,
    cost: true,
    time: true,
  }

  return {
    columnGroupingModel,
    initialColumnGroupVisibility,
  }
}